import { useEffect, useState } from 'react';

export const useVisibleDate = () => {
    const [visibleDate, setVisibleDate] = useState('');

    useEffect(() => {
        const headers = document.querySelectorAll('[data-date-header]');

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisibleDate(
                            entry.target.getAttribute('data-date-header') || ''
                        );
                    }
                });
            },
            {
                rootMargin: '-50px 0px -80% 0px',
                threshold: 0,
            }
        );

        headers.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return visibleDate;
};
